import * as React from "react";

export default function FileSearchingDuff(props: React.SVGProps<any>) {
  return (
    <svg width={458} height={424} {...props}>
      <defs>
        <linearGradient id="prefix__a" x1="50%" x2="50%" y1="100%" y2="0%">
          <stop offset="0%" stopColor="gray" stopOpacity={0.25} />
          <stop offset="54%" stopColor="gray" stopOpacity={0.12} />
          <stop offset="100%" stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient id="prefix__b" x1="50%" x2="50%" y1="100%" y2="0%">
          <stop offset="0%" stopColor="gray" stopOpacity={0.25} />
          <stop offset="54%" stopColor="gray" stopOpacity={0.12} />
          <stop offset="100%" stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient id="prefix__c" x1="50%" x2="50%" y1="100%" y2="0%">
          <stop offset="0%" stopColor="gray" stopOpacity={0.25} />
          <stop offset="54%" stopColor="gray" stopOpacity={0.12} />
          <stop offset="100%" stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient id="prefix__h" x1="0%" y1="50%" y2="50%">
          <stop offset="0%" stopColor="gray" stopOpacity={0.25} />
          <stop offset="54%" stopColor="gray" stopOpacity={0.12} />
          <stop offset="100%" stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient id="prefix__i" x1=".006%" x2="100.006%" y1="50.002%" y2="50.002%">
          <stop offset="0%" stopColor="gray" stopOpacity={0.25} />
          <stop offset="54%" stopColor="gray" stopOpacity={0.12} />
          <stop offset="100%" stopColor="gray" stopOpacity={0.1} />
        </linearGradient>
        <linearGradient id="prefix__j" x1="50%" x2="50%" y1="100%" y2=".001%">
          <stop offset="0%" stopColor="#B3B3B3" stopOpacity={0.25} />
          <stop offset="54%" stopColor="#B3B3B3" stopOpacity={0.1} />
          <stop offset="100%" stopColor="#B3B3B3" stopOpacity={0.05} />
        </linearGradient>
        <linearGradient id="prefix__k" x1="49.98%" x2="49.98%" y1="99.949%" y2="0%">
          <stop offset="0%" stopOpacity={0.12} />
          <stop offset="55%" stopOpacity={0.09} />
          <stop offset="100%" stopOpacity={0.02} />
        </linearGradient>
        <linearGradient id="prefix__l" x1="49.989%" x2="49.989%" y1="100.006%" y2=".008%">
          <stop offset="0%" stopOpacity={0.12} />
          <stop offset="55%" stopOpacity={0.09} />
          <stop offset="100%" stopOpacity={0.02} />
        </linearGradient>
        <path id="prefix__d" d="M.294.391h78.214v52.69H.294z" />
        <path id="prefix__f" d="M.294.228h78.214v52.69H.294z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          fill="url(#prefix__a)"
          fillRule="nonzero"
          d="M.082.114h243.926v327.567H.082z"
          opacity={0.5}
          transform="translate(83.767 71.21)"
        />
        <path fill="#F2F2F2" fillRule="nonzero" d="M87.025 75.771H323.33v316.141H87.025z" />
        <path fill="#E0E0E0" fillRule="nonzero" d="M105.449 89.1h81.309v2.539h-81.309z" />
        <path fill="#8195EE" fillRule="nonzero" d="M105.449 100.526h81.309v2.539h-81.309z" opacity={0.7} />
        <path
          fill="#E0E0E0"
          fillRule="nonzero"
          d="M198.827 89.1h81.309v2.539h-81.309zm12.702 72.373h81.309v2.539h-81.309zm1.909 6.98h81.309v2.539h-81.309zm3.813 6.985h81.309v2.539h-81.309zm-5.722 98.395h81.309v2.539h-81.309zm1.909 6.985h81.309v2.539h-81.309zm3.813 6.98h81.309v2.539h-81.309z"
        />
        <path
          fill="url(#prefix__b)"
          fillRule="nonzero"
          d="M.016.087h86.389v87.605H.016z"
          opacity={0.5}
          transform="translate(106.069 135.354)"
        />
        <path fill="#F5F5F5" fillRule="nonzero" d="M106.629 137.349h85.029v83.794h-85.029z" />
        <path
          fill="url(#prefix__c)"
          fillRule="nonzero"
          d="M.294.005h79.307v54.593H.294z"
          opacity={0.5}
          transform="translate(109.333 142.42)"
        />
        <path fill="#FFF" fillRule="nonzero" d="M110.17 143.062h78.214v52.69H110.17z" />
        <g transform="translate(207.242 175.58)">
          <mask id="prefix__e" fill="#fff">
            <use xlinkHref="#prefix__d" />
          </mask>
          <g fill="#6C63FF" fillRule="nonzero" mask="url(#prefix__e)" opacity={0.4}>
            <g transform="translate(-106.613 -30.985)">
              <path d="M2.91 49.255L22.606 18.78l8.257 13.329L48.65 13.704 63.897 32.11 77.234 4.816l34.302 54.593L.37 55.599z" />
              <ellipse cx={18.157} cy={6.083} rx={5.717} ry={5.713} />
            </g>
          </g>
        </g>
        <path
          fill="url(#prefix__b)"
          fillRule="nonzero"
          d="M.016.473h86.389v87.605H.016z"
          opacity={0.5}
          transform="translate(106.069 247.333)"
        />
        <path fill="#F5F5F5" fillRule="nonzero" d="M106.629 249.709h85.029v83.794h-85.029z" />
        <path
          fill="url(#prefix__c)"
          fillRule="nonzero"
          d="M.294.391h79.307v54.593H.294z"
          opacity={0.5}
          transform="translate(109.333 254.4)"
        />
        <path fill="#FFF" fillRule="nonzero" d="M110.17 255.422h78.214v52.69H110.17z" />
        <g transform="translate(207.242 288.103)">
          <mask id="prefix__g" fill="#fff">
            <use xlinkHref="#prefix__f" />
          </mask>
          <g fill="#BDBDBD" fillRule="nonzero" mask="url(#prefix__g)" opacity={0.4}>
            <g transform="translate(-106.613 -30.985)">
              <path d="M2.91 49.092l19.696-30.474 8.257 13.334L48.65 13.541l15.247 18.411L77.234 4.653l34.302 54.593L.37 55.44z" />
              <ellipse cx={18.157} cy={5.925} rx={5.717} ry={5.713} />
            </g>
          </g>
        </g>
        <path
          fill="url(#prefix__h)"
          fillRule="nonzero"
          d="M-11.698 62.657l327.576.04.03 243.92-327.575-.04z"
          opacity={0.5}
          transform="rotate(-78.76 245.11 139.525)"
        />
        <path fill="#FFF" fillRule="nonzero" d="M124.135 370.196l61.662-310.078 231.773 46.03-61.662 310.078z" />
        <path
          fill="#E0E0E0"
          fillRule="nonzero"
          d="M199.8 77.775l164.487 32.668-.495 2.49-164.487-32.668zM152.998 313.14l164.486 32.666-.495 2.49-164.486-32.667zm-2.853 14.315l127.103 25.243-.495 2.49-127.103-25.244z"
        />
        <path
          fill="#8195EE"
          fillRule="nonzero"
          d="M147.298 341.78l47.35 9.404-.496 2.49-47.349-9.404zm49.65-249.681l82.24 16.333-.495 2.49-82.24-16.333z"
          opacity={0.7}
        />
        <path fill="#E0E0E0" fillRule="nonzero" d="M194.107 106.418l148.283 29.45-.495 2.49-148.284-29.45z" />
        <path
          fill="#2F4EDA"
          fillRule="nonzero"
          d="M191.256 120.742l36.135 7.176-.495 2.49-36.135-7.176z"
          opacity={0.7}
        />
        <path fill="#E0E0E0" fillRule="nonzero" d="M188.411 135.063l164.486 32.667-.495 2.49-164.486-32.667z" />
        <path
          fill="url(#prefix__i)"
          fillRule="nonzero"
          d="M39.108-17.871l86.335.01.019 150.544-86.335-.01z"
          opacity={0.5}
          transform="rotate(-78.76 294.173 41.662)"
        />
        <path fill="#FFF" fillRule="nonzero" d="M203.74 196.361l145.792 28.955-16.468 82.81-145.792-28.954z" />
        <path fill="#E0E0E0" fillRule="nonzero" d="M185.563 149.388l164.487 32.667-.496 2.49-164.486-32.667z" />
        <path fill="#6C63FF" fillRule="nonzero" d="M216.78 210.6l18.07 3.59-12.011 60.396-18.07-3.589z" />
        <path
          fill="#D1D9FA"
          fillRule="nonzero"
          d="M245.214 236.96l18.07 3.59-8.048 40.472-18.07-3.589zm28.689 25.116l18.07 3.588-4.334 21.79-18.07-3.588zm36.856-15.982l18.07 3.589-8.792 44.21-18.07-3.589z"
        />
        <path
          fill="url(#prefix__j)"
          fillRule="nonzero"
          d="M381.549 190.805a84.822 84.822 0 00-60.487-26.006 84.823 84.823 0 00-60.872 25.093c-32.093 32.333-32.637 84.98-1.246 117.997 28.474 29.951 74.41 35.017 108.734 11.992l61.297 63.714a4.13 4.13 0 005.837.114l15.274-14.677a4.124 4.124 0 00.114-5.833l-61.28-63.708c24.253-33.218 21.146-79.042-7.371-108.686zm-19.093 102.44c-24.146 23.199-62.54 22.443-85.753-1.687-23.215-24.13-22.46-62.499 1.686-85.698 24.145-23.2 62.538-22.447 85.754 1.683a60.589 60.589 0 0116.919 43.2 60.592 60.592 0 01-18.606 42.502z"
        />
        <path
          fill="url(#prefix__k)"
          fillRule="nonzero"
          d="M275.502 232.689c-6.821 0-6.832 10.595 0 10.595s6.832-10.595 0-10.595z"
        />
        <path
          fill="url(#prefix__l)"
          fillRule="nonzero"
          d="M323.048 198.753c-18.358-.413-35.063 8.79-43.945 22.684-2.9 4.533 5.33 8.54 8.213 4.028 7.354-11.503 21.328-18.808 36.444-18.428 15.84.397 30.254 9.453 37.886 22.02 2.894 4.768 10.482.436 7.615-4.304-9.28-15.22-27.251-25.55-46.213-26z"
        />
        <path
          fill="#3F5FE9"
          fillRule="nonzero"
          d="M388.201 187.587a84.822 84.822 0 00-60.487-26.006 84.823 84.823 0 00-60.872 25.093c-32.093 32.333-32.636 84.98-1.246 117.997 28.476 29.95 74.412 35.013 108.735 11.986l61.291 63.72a4.13 4.13 0 005.837.114l15.274-14.677a4.124 4.124 0 00.114-5.833l-61.297-63.714c24.257-33.211 21.158-79.031-7.349-108.68zM369.11 289.983c-24.147 23.199-62.54 22.444-85.754-1.687-23.214-24.13-22.46-62.498 1.686-85.698 24.146-23.2 62.539-22.446 85.754 1.683a60.589 60.589 0 0116.919 43.2 60.592 60.592 0 01-18.605 42.502z"
        />
        <path
          fill="#6C63FF"
          fillRule="nonzero"
          d="M282.154 229.466c-6.82 0-6.832 10.594 0 10.594s6.832-10.594 0-10.594zm47.546-33.931c-18.358-.413-35.062 8.79-43.945 22.684-2.9 4.533 5.33 8.54 8.214 4.028 7.354-11.503 21.328-18.809 36.444-18.428 15.84.397 30.254 9.453 37.885 22.02 2.894 4.768 10.482.436 7.616-4.304-9.296-15.264-27.247-25.593-46.214-26z"
        />
        <path fill="#BFCCDA" fillRule="nonzero" d="M66.062 361.438h1.904v10.79h-1.904z" />
        <path
          fill="#BFCCDA"
          fillRule="nonzero"
          d="M72.415 365.88v1.902H61.618v-1.903zM311.065 4.865a2.332 2.332 0 01-1.3-2.821 1.169 1.169 0 00-2.056-1.038 1.12 1.12 0 00-.131.228 2.334 2.334 0 01-2.823 1.3 1.17 1.17 0 00-1.028 2.066v-.001c.07.052.147.096.228.13a2.332 2.332 0 011.3 2.821 1.169 1.169 0 002.072 1.027 1.12 1.12 0 00.131-.227 2.334 2.334 0 012.823-1.3 1.17 1.17 0 001.039-2.055 1.12 1.12 0 00-.255-.13zM74.76 84.854a2.332 2.332 0 01-1.3-2.82 1.169 1.169 0 00-2.056-1.038v-.001a1.12 1.12 0 00-.131.228 2.334 2.334 0 01-2.823 1.3 1.17 1.17 0 00-1.039 2.055c.07.051.147.095.228.13a2.332 2.332 0 011.3 2.82 1.169 1.169 0 002.056 1.038v.001a1.12 1.12 0 00.131-.228 2.334 2.334 0 012.823-1.3 1.17 1.17 0 001.039-2.055 1.12 1.12 0 00-.228-.13zm336.037 330.101a2.332 2.332 0 01-1.3-2.822 1.169 1.169 0 00-2.056-1.038 1.12 1.12 0 00-.131.228 2.334 2.334 0 01-2.823 1.3 1.17 1.17 0 00-1.039 2.055c.07.052.147.096.228.13a2.332 2.332 0 011.3 2.821 1.169 1.169 0 002.056 1.038 1.12 1.12 0 00.131-.228 2.334 2.334 0 012.823-1.3 1.17 1.17 0 001.039-2.055v.001a1.12 1.12 0 00-.228-.13z"
        />
        <ellipse cx={174.687} cy={41.492} fill="#BFCCDA" fillRule="nonzero" rx={3.813} ry={3.811} />
        <ellipse cx={447.834} cy={89.1} fill="#BFCCDA" fillRule="nonzero" rx={3.813} ry={3.811} />
        <ellipse cx={426.239} cy={202.732} fill="#BFCCDA" fillRule="nonzero" rx={3.813} ry={3.811} />
        <ellipse cx={3.813} cy={16.096} fill="#BFCCDA" fillRule="nonzero" opacity={0.5} rx={3.813} ry={3.811} />
      </g>
    </svg>
  );
}
